
import React from 'react';
import { CommandButton as FabricCommandButton } from 'office-ui-fabric-react/lib/Button';
import { getTheme } from 'office-ui-fabric-react/lib/Styling';

const styles = {
    label: {
        color: getTheme().semanticColors.link
    },
    labelHovered: {
        color: getTheme().semanticColors.linkHovered
    },
    labelDisabled: {
        color: getTheme().semanticColors.buttonTextDisabled
    }
};

const CommandButton = (props) => {

    const getIconProps = (menuItem) => {
        return menuItem.icon
            ? {iconName: menuItem.icon}
            : null;
    }

    const getMenuProps = () => {
        return props.items
            ? {
                items: props.items.map((item, index) => {
                    return {
                        key: index,
                        text: item.text,
                        title: item.title,
                        onClick: item.onClick,
                        iconProps: getIconProps(item)
                    };
                })
            }
            : null;
    }

    const getStyles = () => {
        return {
            ...styles,
            ...(props.styles || {})
        };
    }

    return (
        <FabricCommandButton
            onClick={props.onClick}
            text={props.text}
            title={props.title}
            styles={getStyles()}
            iconProps={getIconProps(props)}
            disabled={props.disabled || (!props.onClick && !props.items)}
            menuProps={getMenuProps()}
        />
    );
}

export default CommandButton;
